export enum Origin{
    FANAR = "fanar",
}